<!--
 * @Description: file content
 * @Author: 前胡
 * @LastEditors: 前胡
 * @Date: 2020-05-05 10:06:21
 * @LastEditTime: 2020-05-12 14:18:56
 -->
<template>
  <div class="app-home-d-block">
    <div class="default-c-box">
      <img src="https://oss.zheyi360.com/app-image/home-config/recommend.png" alt="精品推荐" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecommendGoods',
  props: {
    component: {
      type: Object,
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.comp-content {
  background-repeat: no-repeat;
}
.text-box {
  display: block;
}
</style>
